import axios, { AxiosInstance } from "axios";
import API_CONFIG, { REQUEST_HEADERS } from "../config";
import { setupInterceptors } from "../config/interceptors";

class ApiClient {
  private readonly instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: API_CONFIG.FULL_BASE_URL,
      timeout: API_CONFIG.TIMEOUT,
      headers: REQUEST_HEADERS,
    });

    setupInterceptors(this.instance);
  }

  getInstance(): AxiosInstance {
    return this.instance;
  }

  get<T = unknown>(url: string, params?: Record<string, unknown>) {
    return this.instance.get<T>(url, { params });
  }

  post<T = unknown>(url: string, data?: unknown) {
    return this.instance.post<T>(url, data);
  }

  put<T = unknown>(url: string, data?: unknown) {
    return this.instance.put<T>(url, data);
  }

  patch<T = unknown>(url: string, data?: unknown) {
    return this.instance.patch<T>(url, data);
  }

  delete<T = unknown>(url: string) {
    return this.instance.delete<T>(url);
  }

  uploadFile<T = unknown>(url: string, formData: FormData) {
    return this.instance.post<T>(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export const apiClient = new ApiClient();
export default apiClient;
